import React, { useContext } from 'react'
import info1 from '../utils/userContext';

const Footer = () => {
  const {user}=useContext(info1);
  return (
    <div></div>
  )
}

export default Footer;